import FormFormato from "./Form/Form";

export default function AgregarFormatosPersonal() {
    return (
        <>
            <h3>Agregar nuevo formato</h3>
            <FormFormato/>
        </>
    )
}